import { render, staticRenderFns } from "./page-create-animation.vue?vue&type=template&id=a6daf612&scoped=true&"
import script from "./page-create-animation.vue?vue&type=script&lang=ts&"
export * from "./page-create-animation.vue?vue&type=script&lang=ts&"
import style0 from "./page-create-animation.vue?vue&type=style&index=0&id=a6daf612&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6daf612",
  null
  
)

export default component.exports